import { Box, Breadcrumbs, Divider, Link, Typography } from "@mui/material"
import React, { ReactNode, useEffect, useState } from "react"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import "./breadcrumb.scss"

type Props = {
  paths: { name: string; link: string; color?: string }[]
  children?: ReactNode
}

const BreadCrumb = ({ paths, children }: Props) => {
  const [crumbs, setCrumbs] = useState<ReactNode[]>([])

  useEffect(() => {
    let crumbs: ReactNode[] = []

    paths.map((path, index) => {
      if (index === paths.length - 1) {
        crumbs.push(
          <Typography
            key={index}
            className="link link-last"
            color={path.color ? `${path.color} !important` : ""}
          >
            {path.name}
          </Typography>
        )
      } else {
        if (path.link == "") {
          crumbs.push(
            <Typography
              key={index}
              className="link"
              color={path.color ? `${path.color} !important` : ""}
            >
              {path.name}
            </Typography>
          )
        } else {
          crumbs.push(
            <Link
              underline="hover"
              key={index}
              href={path.link}
              className="link"
              color={path.color ? `${path.color} !important` : ""}
            >
              {path.name}
            </Link>
          )
        }
      }
    })

    setCrumbs(crumbs)
  }, [paths])

  return (
    <Box className="breadcrumb-container">
      <Box display="flex" height="35px">
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" sx={{ color: "#333333" }} />}
          aria-label="breadcrumb"
          sx={{ my: "0px", "& p": { color: "red" } }}
        >
          {crumbs}
        </Breadcrumbs>
        <Box sx={{ ml: "auto" }}>{children}</Box>
      </Box>
      <Divider sx={{ mt: "5px" }} />
    </Box>
  )
}

export default BreadCrumb
